import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import {Injectable} from '@angular/core';
import {SessionApiSvc} from '../services/api.services/session.api.svc';
import {Store} from '@ngxs/store';

@Injectable()
export class AlreadyLoggedGuard  {

  constructor(private router: Router, private sessionApiSvc: SessionApiSvc, private store: Store) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const sessionId: string = localStorage.getItem('intosite_session');
    if (sessionId) {
      console.log('You are already logged in, ENJOY');
      this.router.navigate([''], {queryParams: {...route.queryParams, company: null, token: null}});
      return false;
    }

    return true;
  }
}
